import { render } from "./main.vue?vue&type=template&id=513afb9c&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=513afb9c&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513afb9c"]])

export default __exports__